import { css, Interpolation, Theme } from '@emotion/react'

export const wrapper: Interpolation<Theme> = css`
  padding-bottom: 40px;
`

export const selectsWrapper: Interpolation<Theme> = (theme) => css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin: 24px 0;

  div {
    overflow: hidden;
  }

  ${theme.breakpoints.down(650)} {
    grid-template-columns: 1fr;
  }
`

export const questionsCount: Interpolation<Theme> = css`
  margin: 24px 0;
`

export const tabsBlock: Interpolation<Theme> = css`
  margin: 24px 0;
`

export const link: Interpolation<Theme> = css`
  text-decoration: none;
`
